import React  from 'react';
import { useStaticQuery, graphql, Link} from "gatsby"
import styled  from 'styled-components';

import MobileMenu from './menu';
import IconLogo from './logo';

const StyledHeader = styled.header`
  ${({ theme }) => theme.mixins.flexBetween};
  padding: 0px 50px;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background:#fff;
  height: var(--nav-height);
  
  @media (max-width: 1080px) {
    padding: 0 40px;
  }
  
  @media (max-width: 768px) {
    padding: 0 25px;
  }
`;

const StyledNav = styled.nav`
  ${({ theme }) => theme.mixins.flexBetween};
  position: relative;
  width: 100%;
  color: var(--lightest-slate);
  font-family: var(--font-mono);
  counter-reset: item 0;
  z-index: 12;
  
  .logo {
    ${({ theme }) => theme.mixins.flexCenter};
    a > div{
      height:100px;
    }

    a {
    	width:auto;
      text-align:center;
      padding:20px 0;
      
      img{
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      
      svg {
        fill: none;
        transition: var(--transition);
        user-select: none;
      }
    }
  }
`;

const StyledLinks = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    display: none;
  }

  ol,ul {
    ${({ theme }) => theme.mixins.flexBetween};
    padding: 0;
    margin: 0;
    list-style: none;

    li {
      margin: 0 5px;
      position: relative;
      counter-increment: item 1;
      font-size: 16px;

      a {
        font-family: var(--title-font);
        padding: 10px;
        color: #000;
      }

      &:last-child a {
        ${({ theme }) => theme.mixins.smallButton};
        margin-left: 15px;
      }
    }
  }
`;

const Nav = () => {
  const data = useStaticQuery(graphql`
    query NavQuery {
      site {
        siteMetadata{
          menu{
            name
            url
          }
        }
      }
    }
  `)


  return (
    <StyledHeader>

      <StyledNav>
      
        <div className="logo" tabIndex="-1">
          <Link to="/" aria-label="home">
            <IconLogo />
          </Link>
        </div>
        
        <StyledLinks>
          <ul>
            {
              data.site.siteMetadata.menu &&
              data.site.siteMetadata.menu.map(({ url, name }, i) => (
                <li key={i}>
                  <Link to={url}>{name}</Link>
                </li>
                      
              ))}
                
          </ul>
  
        </StyledLinks>

        <MobileMenu />
                
      </StyledNav>

    </StyledHeader>
  );
};

export default Nav;
